// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Common/ConfirmModal.css */
/* Styled confirmation modal */

.confirm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.confirm-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 420px;
  animation: slideIn 0.2s ease-out;
  overflow: hidden;
}

.confirm-modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #E5E7EB;
}

.confirm-modal.danger .confirm-modal-header {
  background: linear-gradient(135deg, #FEF2F2 0%, #FEE2E2 100%);
  border-bottom-color: #FECACA;
}

.confirm-modal.warning .confirm-modal-header {
  background: linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%);
  border-bottom-color: #FDE68A;
}

.confirm-modal.info .confirm-modal-header {
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  border-bottom-color: #BFDBFE;
}

.confirm-modal-icon {
  font-size: 24px;
}

.confirm-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
}

.confirm-modal-body {
  padding: 20px 24px;
}

.confirm-modal-message {
  margin: 0 0 12px 0;
  font-size: 14px;
  line-height: 1.6;
  color: #4B5563;
}

.confirm-modal-message:last-child {
  margin-bottom: 0;
}

.confirm-modal-details {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.confirm-modal-details li {
  font-size: 13px;
  color: #6B7280;
  margin-bottom: 4px;
  line-height: 1.5;
}

.confirm-modal-details li:last-child {
  margin-bottom: 0;
}

.confirm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 20px;
  background: #F9FAFB;
  border-top: 1px solid #E5E7EB;
}

.confirm-modal-btn {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
}

.confirm-modal-btn.cancel {
  background: white;
  color: #4B5563;
  border: 1px solid #D1D5DB;
}

.confirm-modal-btn.cancel:hover {
  background: #F3F4F6;
  border-color: #9CA3AF;
}

.confirm-modal-btn.confirm {
  color: white;
}

.confirm-modal-btn.confirm.danger {
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);
}

.confirm-modal-btn.confirm.danger:hover {
  background: linear-gradient(135deg, #DC2626 0%, #B91C1C 100%);
}

.confirm-modal-btn.confirm.warning {
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
}

.confirm-modal-btn.confirm.warning:hover {
  background: linear-gradient(135deg, #D97706 0%, #B45309 100%);
}

.confirm-modal-btn.confirm.info {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
}

.confirm-modal-btn.confirm.info:hover {
  background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%);
}

.confirm-modal-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/ConfirmModal.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C,8BAA8B;;AAE9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C","sourcesContent":["/* src/components/Common/ConfirmModal.css */\n/* Styled confirmation modal */\n\n.confirm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.15s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.confirm-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  width: 90%;\n  max-width: 420px;\n  animation: slideIn 0.2s ease-out;\n  overflow: hidden;\n}\n\n.confirm-modal-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.confirm-modal.danger .confirm-modal-header {\n  background: linear-gradient(135deg, #FEF2F2 0%, #FEE2E2 100%);\n  border-bottom-color: #FECACA;\n}\n\n.confirm-modal.warning .confirm-modal-header {\n  background: linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%);\n  border-bottom-color: #FDE68A;\n}\n\n.confirm-modal.info .confirm-modal-header {\n  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);\n  border-bottom-color: #BFDBFE;\n}\n\n.confirm-modal-icon {\n  font-size: 24px;\n}\n\n.confirm-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1F2937;\n}\n\n.confirm-modal-body {\n  padding: 20px 24px;\n}\n\n.confirm-modal-message {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #4B5563;\n}\n\n.confirm-modal-message:last-child {\n  margin-bottom: 0;\n}\n\n.confirm-modal-details {\n  margin: 0;\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.confirm-modal-details li {\n  font-size: 13px;\n  color: #6B7280;\n  margin-bottom: 4px;\n  line-height: 1.5;\n}\n\n.confirm-modal-details li:last-child {\n  margin-bottom: 0;\n}\n\n.confirm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px 20px;\n  background: #F9FAFB;\n  border-top: 1px solid #E5E7EB;\n}\n\n.confirm-modal-btn {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: none;\n}\n\n.confirm-modal-btn.cancel {\n  background: white;\n  color: #4B5563;\n  border: 1px solid #D1D5DB;\n}\n\n.confirm-modal-btn.cancel:hover {\n  background: #F3F4F6;\n  border-color: #9CA3AF;\n}\n\n.confirm-modal-btn.confirm {\n  color: white;\n}\n\n.confirm-modal-btn.confirm.danger {\n  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);\n}\n\n.confirm-modal-btn.confirm.danger:hover {\n  background: linear-gradient(135deg, #DC2626 0%, #B91C1C 100%);\n}\n\n.confirm-modal-btn.confirm.warning {\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n}\n\n.confirm-modal-btn.confirm.warning:hover {\n  background: linear-gradient(135deg, #D97706 0%, #B45309 100%);\n}\n\n.confirm-modal-btn.confirm.info {\n  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);\n}\n\n.confirm-modal-btn.confirm.info:hover {\n  background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%);\n}\n\n.confirm-modal-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
